import { render, staticRenderFns } from "./VResponsiveBounds.vue?vue&type=template&id=1c959fbe"
import script from "./VResponsiveBounds.vue?vue&type=script&lang=js"
export * from "./VResponsiveBounds.vue?vue&type=script&lang=js"
import style0 from "./VResponsiveBounds.vue?vue&type=style&index=0&id=1c959fbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
